<template>
    <HeaderCardsLayout variant="No-Logo">
        <template #headline>{{ $t('event-wiki') }}</template>
        <template #icon>
            <BallotIcon class="w-12 h-12" />
        </template>
        <template #buttons>
            <LinkButton
                variant="Info-Strong"
                size="Base"
                :disabled-explanation="createEventSeriesDisabledExplanation"
                :to="getCreateEventSeriesLink()"
            >
                <template #icon>
                    <PlusIcon class="size-5" />
                </template>
                {{ $t('event-series-create') }}
            </LinkButton>
        </template>
        <template #body>
            <PaddedContent>
                <EventSeriesList />
            </PaddedContent>
        </template>
    </HeaderCardsLayout>
</template>

<script setup lang="ts">
import auth from '@/auth/auth';
import LinkButton from '@/components/Button/LinkButton.vue';
import BallotIcon from '@/components/Icon/BallotIcon.vue';
import PlusIcon from '@/components/Icon/PlusIcon.vue';
import HeaderCardsLayout from '@/components/Layout/HeaderCardsLayout.vue';
import PaddedContent from '@/components/Layout/PaddedContent.vue';
import EventSeriesList from '@/event/components/EventSeriesList.vue';
import { useHeadSafe } from '@unhead/vue';
import { useFluent } from 'fluent-vue';
import { computed } from 'vue';
import { getCreateEventSeriesLink } from '../event';

const fluent = useFluent();
useHeadSafe({ title: () => fluent.$t('event-wiki') });

const createEventSeriesDisabledExplanation = computed(() =>
    auth.isAdmin() ? undefined : fluent.$t('no-permission-to-create'),
);
</script>
